import { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'

import { ListCell } from '@src/components/table-list/cells'
import { Subtitle1 } from '@src/elements/typography/typography'
import { Popover } from '@src/components/popover/popover'
import { OptionGroup } from '@src/elements/select/option-group'
import { MenuButton } from '@src/elements/button/button'
import Checkup from '@src/data/checkup'

@Component
export class CheckupOptionsCell extends ListCell {

  item: string

  private checkup: Checkup

  constructor () {
    super()
  }

  redirect (action: string) {
    this.$store.dispatch('setCheckup', this.checkup)
    this.$router.push({ path: `/members/checkup/${this.$route.params.id}/${this.checkup.id}`, query: { action: action } })
  }

  render (h: CreateElement) {
    return <div class='cell options-cell text-cell'>
      <MenuButton>
        <Popover>
          <OptionGroup>
            <div onClick={() => this.redirect('view')} ref='viewCheckup'><Subtitle1>{this.$t('PAGE.MEMBERS.CHECKUPS.VIEW_CHECKUP')}</Subtitle1></div>
          </OptionGroup>
        </Popover>
      </MenuButton>
    </div>
  }

  created () {
    this.init()
  }

  private init () {
    this.checkup = this.item[this.name].checkup
  }
}
